<template>
    <div class="row" id="project_empty">
        <div class="col-lg-12">
            
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'project_empty',
    components: {
    },
    data() {
        return {
            
        }
    }
}
</script>

<style>
    #project_empty {
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/projects/project_empty.vue